import { Notifications } from "@mantine/notifications";
import { Outlet } from "react-router-dom";

import { PermissionsProvider } from "#app/PermissionsProvider";
import { ThemeProvider } from "#app/theme/ThemeProvider";
import { OptimizationInvalidationModal } from "#modules/optimizations/view/OptimizationInvalidationModal";

export const AuthenticatedLayout = () => {
  return (
    <PermissionsProvider>
      <ThemeProvider>
        <Notifications position="top-right" />
        <Outlet />
        <OptimizationInvalidationModal />
      </ThemeProvider>
    </PermissionsProvider>
  );
};
